import { Directive, ElementRef } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[emsStartSpaceValidator]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: StartSpacePatternDirective, multi: true }
  ]
})
export class StartSpacePatternDirective {
  constructor(public el: ElementRef) { }

  validate() {
    const elementVal = this.el.nativeElement.value;
    if (elementVal.startsWith(' ')) {
      return {
        emsStartSpacePattern: false
      };
    }
    return null;
  }
}
